export const PATIENT_CASES_MODAL_TABS_NAMES = {
  INFO: 'Case Information',
  IMAGES: 'Images',
  VIDEOS: 'Videos',
};
